{
    "notes__delete_confirmation__title": "Delete log interaction",
    "notes__delete_confirmation__description": "The log interaction will be deleted permanently. This action cannot be undone.",
    "notes__form_create_title": "Log interaction",
    "notes__form_create_toast__success_title": "Log interaction created successfully",
    "notes__tasks_section_title": "Tasks",
    "notes__tasks_assignee_me": "Me",
    "notes__tasks_quick_action_call": "Call",
    "notes__tasks_quick_action_clarify_price": "Clarify price",
    "notes__tasks_quick_action_task": "Task",
    "notes__tasks_summary_open": "open",
    "notes__tasks_summary_completed": "completed",
    "notes__offers_section_title": "Open quotes",
    "notes__offers_section_empty": "No open quotes",
    "notes__offers_section_summary_one": "{{count}} open · {{total}}",
    "notes__offers_section_summary_other": "{{count}} open · {{total}}",
    "notes__offers_section_loading": "Loading quotes…",
    "notes__offers_draft_title": "Draft",
    "notes__offers_draft_state": "Draft",
    "notes__ai_insights_section_title": "Sales recommendations",
    "notes__ai_insights_section_empty": "No sales recommendations",
    "notes__ai_insights_section_loading": "Loading recommendations…",
    "notes__ai_insights_show_more_one": "{{count}} more",
    "notes__ai_insights_show_more_other": "{{count}} more",
    "notes__ai_insights_more_articles_one": "{{count}} more article",
    "notes__ai_insights_more_articles_other": "{{count}} more articles",
    "notes__ai_insights_outcome_action": "Add response",
    "notes__ai_insights_outcome_none": "None",
    "notes__offers_quote_title": "Quote {{displayId}}",
    "notes__offers_positions_count_one": "{{count}} item",
    "notes__offers_positions_count_other": "{{count}} items",
    "notes__offers_positions_more_one": "{{count}} more item",
    "notes__offers_positions_more_other": "{{count}} more items",
    "notes__offers_margin_label": "GM",
    "notes__offers_kommission": "PO {{number}}",
    "notes__offers_task_action": "Task",
    "notes__offers_confirm_suggestion": "Mark as done",
    "notes__offers_lost_suggestion": "Mark as lost",
    "notes__offers_confirm_task": "Mark {{offer}} as done",
    "notes__offers_lost_task": "Mark {{offer}} as lost",
    "notes__form_edit_title": "Edit log interaction",
    "notes__form_edit_save": "Save",
    "notes__form__follow_ups_title": "Activities",
    "notes__form_edit_toast__success_title": "Log interaction updated successfully",
    "notes__delete_confirmation__toast__success_title": "Log interaction deleted",
    "notes__delete_confirmation__toast__success_description": "The log interaction was deleted successfully",
    "notes__type__visit": "Log",
    "notes__type__visit_not_reached": "Visit, not reached",
    "notes__type__phone_call": "Phone Call",
    "notes__type__phone_call_not_reached": "Phone call, not reached",
    "notes__type__note": "Note",
    "notes__not_reached__active_label": "Customer not reached",
    "notes__not_reached__back": "Back",
    "notes__not_reached__reason_placeholder": "Reason (optional)",
    "notes__not_reached__submit": "Save not reached",
    "notes__placeholder__event": "How did it go? What was discussed?",
    "notes__placeholder__phone_call": "Log phone call…",
    "notes__placeholder__note": "Log note…",
    "notes__form__customer_label": "Customer",
    "notes__form__event_label": "Event",
    "notes__form__agenda_label": "Agenda",
    "notes__form__date_label": "Date",
    "notes__form__time_label": "Time",
    "notes__form__date_prefill_source": "Based on last visit",
    "notes__form__last_event": "Last event",
    "notes__form__date_now": "Now",
    "notes__form__date_clear": "Clear date",
    "notes__form__protokoll_label": "Log",
    "notes__pin_note": "Pin note",
    "notes__pinned_label": "Pinned",
    "notes__pin_success_toast": "Note pinned successfully",
    "notes__unpin_success_toast": "Note unpinned successfully",
    "notes__pin_confirmation_title": "Note already pinned",
    "notes__pin_confirmation_description": "Only one note can be pinned at a time. Would you like to pin this note instead?",
    "notes__pin_confirmation_cancel": "Cancel",
    "notes__pin_confirmation_confirm": "Pin note"
}
